import _ from 'lodash';
import axios from 'axios';

// "undefined" means the URL will be computed from the `window.location` object
const URL = process.env.NODE_ENV === 'production' ? '' : 'https://signal.cryptorabbit.pro'; //'http://localhost:3000';

axios.defaults.baseURL = `${URL}/api`;

axios.interceptors.response.use((response) => {
	// Любой код состояния, находящийся в диапазоне 2xx, вызывает срабатывание этой функции
	// Здесь можете сделать что-нибудь с ответом
	return response;
}, (error) => {
	if (_.get(error, 'response.status') === 403) {
		document.dispatchEvent(new CustomEvent('logout', {}));
	}
	// Любые коды состояния, выходящие за пределы диапазона 2xx, вызывают срабатывание этой функции
	// Здесь можете сделать что-то с ошибкой ответа
	return Promise.reject(error);
});

const API = {
	Auth: {
		login: async ({
			login,
			password
		}) => {
			document.dispatchEvent(new CustomEvent('dimmerOn', {}));
			try {
				const response = await axios.post(`/login`, {
					login,
					password
				});

				return response.data;
			} catch (err) {
				console.error(err);
				throw new Error('Not valid password!');
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		}
	},

	Wallet: {
		get: async (password) => {
			try {
				const response = await axios.get(`/wallet`, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
			}
		}
	},

	Position: {
		get: async (symbol) => {
			try {
				const response = await axios.get(`/position/${symbol}`, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
			}
		},

		close: async (symbol, value) => {
			document.dispatchEvent(new CustomEvent('dimmerOn', {}));
			try {
				const response = await axios.post(`/position/${symbol}/close`, { value }, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		},

		setTP: async (symbol, order) => {
			document.dispatchEvent(new CustomEvent('dimmerOn', {}));
			try {
				const response = await axios.post(`/position/${symbol}/tp`, order, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		},

		setPTP: async (symbol, order) => {
			document.dispatchEvent(new CustomEvent('dimmerOn', {}));
			try {
				const response = await axios.post(`/position/${symbol}/ptp`, order, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		},

		setSL: async (symbol, order) => {
			document.dispatchEvent(new CustomEvent('dimmerOn', {}));
			try {
				const response = await axios.post(`/position/${symbol}/sl`, order, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		},

		setNoLoss: async (symbol, order) => {
			document.dispatchEvent(new CustomEvent('dimmerOn', {}));
			try {
				const response = await axios.post(`/position/${symbol}/nl`, order, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		},

		addTP: async (symbol, order) => {
			document.dispatchEvent(new CustomEvent('dimmerOn', {}));
			try {
				const response = await axios.post(`/position/${symbol}/ptp`, order, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		},

		delete: async (symbol) => {
			document.dispatchEvent(new CustomEvent('dimmerOn', {}));
			try {
				const response = await axios.delete(`/position/${symbol}`, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		},

		users: async (symbol) => {
			document.dispatchEvent(new CustomEvent('dimmerOn', {}));
			try {
				const response = await axios.get(`/position/${symbol}/users`, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		},
	},

	Order: {
		buy: async (symbol, order) => {
			document.dispatchEvent(new CustomEvent('dimmerOn', {}));
			try {
				const response = await axios.post(`/position/${symbol}`, { side: 'Buy', ...order }, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		},

		sell: async (symbol, order) => {
			try {
				document.dispatchEvent(new CustomEvent('dimmerOn', {}));
				const response = await axios.post(`/position/${symbol}`, { side: 'Sell', ...order }, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		},

		closePTP: async (symbol) => {
			try {
				document.dispatchEvent(new CustomEvent('dimmerOn', {}));
				const response = await axios.post(`/orders/${symbol}/close/ptp`, {}, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		},

		closeLimit: async (symbol) => {
			document.dispatchEvent(new CustomEvent('dimmerOn', {}));
			try {
				const response = await axios.post(`/orders/${symbol}/close/limit`, {}, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		},
	},

	Trend: {
		set: async (symbol, trend, side) => {
			document.dispatchEvent(new CustomEvent('dimmerOn', {}));
			try {
				const response = await axios.post(`/trend/${symbol}/${trend}/${side}`, null, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		},
	},

	Symbol: {
		list: async () => {
			try {
				const response = await axios.get(`/symbols/all`, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
				throw err;
			}
		},

		active: async () => {
			try {
				const response = await axios.get(`/symbols/active`, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
				throw err;
			}
		}
	},

	Config: {
		set: async (config) => {
			document.dispatchEvent(new CustomEvent('dimmerOn', {}));
			try {
				const response = await axios.post(`/keys`, config, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
				throw err;
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		},
		setTid: async (tid) => {
			document.dispatchEvent(new CustomEvent('dimmerOn', {}));
			try {
				const response = await axios.post(`/tid`, { tid }, {
					headers: {
						Authorization: localStorage.getItem('token')
					}
				});

				return response.data;
			} catch (err) {
				console.error(err);
				throw err;
			} finally {
				document.dispatchEvent(new CustomEvent('dimmerOff', {}));
			}
		},

	}
};

export default API;
